module.exports = __webpack_public_path__ + "img/img_05.6a05f653.gif";